export const COALITION_EMAIL = 'info@azcitypac.com'

// Google Apps Script Web App endpoint backing the coalition signup sheet.
export const COALITION_SHEET_URL =
  'https://script.google.com/macros/s/AKfycbyt-2HUGhaWJFGrViVphRi8Gf0BejS_B70yJ0sXzEi92vV0kQ_s2zFexEYV7pB9fp97Gg/exec'

const TARGET_FRAME = 'az-city-pac-signup-frame'

export interface CoalitionSignup {
  name: string
  email: string
  city: string
  sector: string
}

function ensureTargetFrame(): HTMLIFrameElement {
  const existing = document.getElementById(TARGET_FRAME)
  if (existing) return existing as HTMLIFrameElement

  const frame = document.createElement('iframe')
  frame.id = TARGET_FRAME
  frame.name = TARGET_FRAME
  frame.setAttribute('aria-hidden', 'true')
  frame.style.display = 'none'
  document.body.appendChild(frame)
  return frame
}

/**
 * Posts the signup to the Apps Script endpoint using a real form submission
 * targeted at a hidden iframe. Unlike fetch(), this is never blocked by CORS
 * and works with Apps Script's redirect-based response.
 */
export async function submitCoalitionSignup(
  signup: CoalitionSignup,
): Promise<'sent'> {
  const frame = ensureTargetFrame()

  const fields: Record<string, string> = {
    name: signup.name.trim(),
    email: signup.email.trim(),
    city: signup.city.trim(),
    sector: signup.sector,
    submittedAt: new Date().toISOString(),
  }

  const form = document.createElement('form')
  form.action = COALITION_SHEET_URL
  form.method = 'POST'
  form.target = TARGET_FRAME
  form.style.display = 'none'

  Object.entries(fields).forEach(([key, value]) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = key
    input.value = value
    form.appendChild(input)
  })

  document.body.appendChild(form)

  await new Promise<void>((resolve) => {
    const done = () => {
      frame.removeEventListener('load', done)
      resolve()
    }

    frame.addEventListener('load', done)
    form.submit()

    // Resolve regardless if the frame never fires load (cross-origin quirks).
    window.setTimeout(done, 4000)
  })

  form.remove()
  return 'sent'
}
